import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import SocialNetworkLinks from "../social-network-links/SocialNetworkLinks";
import { tesetimonials } from "../../constants";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

const WhatPeopleSay = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="relative py-12 bg-baseBlue text-white">
      <h2 className="text-4xl font-bold text-center mb-4">What People Say</h2>
      <p className="text-xl text-center mb-4">
        We are looking forward to your feedback!
      </p>

      <div className="flex justify-center mb-10">
        <SocialNetworkLinks />
      </div>

      <div className="relative max-w-6xl mx-auto px-4">
        {/* Arrows */}
        <div
          ref={prevRef}
          className="absolute z-10 top-1/2 left-[-0px] -translate-y-1/2 text-white text-4xl cursor-pointer"
        >
          ‹
        </div>
        <div
          ref={nextRef}
          className="absolute z-10 top-1/2 right-[-0px] -translate-y-1/2 text-white text-4xl cursor-pointer"
        >
          ›
        </div>

        <Swiper
          modules={[Navigation]}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {tesetimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <div className="flex flex-col bg-white p-6 rounded-lg shadow-lg text-gray-800 min-h-[320px]">
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.img}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full border-2 border-baseBlue"
                  />
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-baseBlue">
                      {testimonial.name}, {testimonial.country && `${testimonial.country}`}
                    </h3>
                  </div>
                </div>
                <div className="italic text-gray-600">
                  <FaQuoteLeft className="text-baseGreen inline-block mr-2" />
                  {testimonial.quote}
                  <FaQuoteRight className="text-baseGreen inline-block ml-2" />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default WhatPeopleSay;
